import React, { useMemo } from "react";
import { useMessage } from "../../../../../../Utils/useMessage";
import { FileMessageItem } from "../../../../../../types";
import { Icon, Progress, Spin, Tooltip } from "antd";
import styles from "./index.module.scss";
import { getFileMessageContent } from "../../../../../../Utils/common";
import MimeIcon from "../../../../../MimeIcon";
import { humanFileSize } from "../../../../../../polyfills";
import classNames from "classnames";

interface FileMessageProps {
    sessionId: string;
    messageId: string;
}

export default function FileMessage({
    sessionId,
    messageId
}: FileMessageProps) {
    const { message } = useMessage<FileMessageItem>(sessionId, messageId);

    const messageContent = useMemo(
        () => getFileMessageContent(message.content),
        [message.content]
    );

    function onClick() {
        if (!messageContent?.url) return;
        window.open(messageContent.url);
    }

    if (!message) return null;

    return (
        <div>
            {message.uploading && <Spin className={styles.spin} size="small" />}

            {message.error && (
                <Tooltip className={styles.error} overlay={message.error}>
                    <Icon type="exclamation-circle" />
                </Tooltip>
            )}

            <span
                className={classNames(styles.link)}
                role="button"
                onClick={onClick}>
                <MimeIcon mimetype={messageContent?.type || ""} />

                <div>
                    <div>{messageContent?.filename}</div>

                    {!!messageContent?.filesize && (
                        <div className={styles.size}>
                            {humanFileSize(messageContent.filesize)}
                        </div>
                    )}
                </div>
            </span>

            {message.percent && message.uploading && (
                <Progress percent={message.percent} />
            )}
        </div>
    );
}
